import React from 'react'
import { Box, makeStyles, Typography, Grid } from '@material-ui/core'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
    root: {
        color: 'gray',
        marginTop: theme.spacing(2)
    },
    pageBackground: {
        height: 350,
        marginTop: -300,
        background: 'url(/img/bg-clipped.png)',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center bottom'
    },
    upperSection: {
        background: '#19191B',
        padding: theme.spacing(10, 0, 6, 0)
    },
    lowerSection: {
        background: '#1E1E20',
        padding: theme.spacing(4, 0, 3, 0),
        '& a': {
            marginRight: theme.spacing(2)
        }
    },
    wrapper: {
        padding: theme.spacing(0, 2),
        maxWidth: '76.875rem',
        margin: 'auto'
    },
    logoWrapper: {},
    logo: {
        maxWidth: '100%',
        width: 245
    },
    headerWrapper: {
        float: 'left',
        width: '100%'
    },
    header: {
        textAlign: 'left!important',
        color: 'white!important',
        borderBottom: '3px solid#FEDC5A',
        paddingBottom: theme.spacing(0.5),
        marginBottom: theme.spacing(2),
        float: 'left',
        fontSize: '1.3125rem!important',
        marginTop: theme.spacing(0.5) + '!important'
    },
    content: {
        color: 'grey!important',
        marginBottom: theme.spacing(2),
        '& a': {
            color: '#FEDC5A!important',
            textDecoration: 'none'
        }
    }
}))

function Footer({ className, children, icon, ...rest }) {
    const classes = useStyles()
    return (
        <Box className={classes.root}>
            <Box className={classes.pageBackground + ' sharpBackgroundImage'}></Box>
            <Box className={classes.upperSection}>
                <Box className={classes.wrapper}>
                    <Grid container spacing={2} className={classes.container}>
                        <Grid item md={7}>
                            <Box className={classes.logoWrapper} mb={4}>
                                <img src="/img/logo-white.png" className={classes.logo} />
                            </Box>
                            <Box>
                                <Typography variant="body1" className={classes.content}>
                                    Rahoo on älykäs yritysrahoituspalvelu, joka auttaa yrityksiä löytämään parhaan mahdollisen rahoituksen.
                                </Typography>
                                <Typography variant="body1" className={classes.content}>
                                    Rahoo on suomalainen yritys, jossa työskentelee rahoitusalan ammattilaisia. Yrityksemme tavoitteena on auttaa ja
                                    tukea yrittäjiä, jotta he menestyvät entistä paremmin.
                                </Typography>
                                <Typography variant="body1" className={classes.content}>
                                    Rahoon päätoimipiste sijaitsee osoitteessa Maariankatu 6a, 20100 Turku ja yritys rekisteröity kaupparekisteriin
                                    Y-tunnuksella 3002206-7 ja nimellä Rahoo Oy.
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item md={1} />
                        <Grid item md={4}>
                            <Box mb={4}>
                                <Box className={classes.headerWrapper}>
                                    <Typography variant="h4" className={classes.header}>
                                        Asiakaspalvelu
                                    </Typography>
                                </Box>
                                <Typography variant="body1" className={classes.content}>
                                    Palvelemme arkisin klo 9-17.
                                </Typography>
                                <Typography variant="body1" className={classes.content}>
                                    Tavoitat meidät numerosta{' '}
                                    <a target="_blank" href="tel:+358248084405">
                                        +358 2 480 84405
                                    </a>
                                    , chatin kautta tai sähköpostitse{' '}
                                    <a target="_blank" href="mailto:asiakaspalvelu@rahoo.fi">
                                        asiakaspalvelu@rahoo.fi
                                    </a>
                                    .
                                </Typography>
                            </Box>
                            <Box>
                                <Box className={classes.headerWrapper}>
                                    <Typography variant="h4" className={classes.header}>
                                        Tietosuoja
                                    </Typography>
                                </Box>
                                <Typography variant="body1" className={classes.content}>
                                    Otamme tietosuoja-asiat vakavasti. Voit tutustua koska tahansa palvelumme tietosuoja- ja evästekäytäntöihin.
                                </Typography>
                                <Typography variant="body1" className={classes.content}>
                                    <a target="_blank" href="https://www.rahoo.fi/tietosuoja">
                                        Tietosuojaseloste
                                    </a>
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <Box className={classes.lowerSection}>
                <Box className={classes.wrapper}>
                    <Grid container spacing={2} className={classes.container}>
                        <Grid item md={8}>
                            <Typography variant="body1" className={classes.content}>
                                <a target="_blank" href="https://www.rahoo.fi/">
                                    Etusivu
                                </a>{' '}
                                <a target="_blank" href="https://www.rahoo.fi/uutiset/">
                                    Uutiset
                                </a>{' '}
                                <a target="_blank" href="https://www.rahoo.fi/kumppaneille/">
                                    Kumppaneille
                                </a>{' '}
                                <a target="_blank" href="https://www.rahoo.fi/laskujen-myynti/">
                                    Laskujen myynti
                                </a>{' '}
                                <a target="_blank" href="https://www.rahoo.fi/laskurahoitus/">
                                    Laskurahoitus
                                </a>
                            </Typography>
                        </Grid>
                        <Grid item md={4}>
                            <Typography variant="body1" className={classes.content}>
                                © Rahoo, All Rights Reserved
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    )
}

Footer.propTypes = {
    className: PropTypes.string
}

export default Footer
